"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _react = _interopRequireWildcard(require("react"));
var _AttachmentIcon = _interopRequireDefault(require("../AttachmentIcon"));
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _Tooltip = _interopRequireWildcard(require("../Tooltip"));
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _filesize = _interopRequireDefault(require("filesize"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./index.css");
var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));
var _styles = require("@material-ui/core/styles");
var _tailwind = _interopRequireWildcard(require("../../tailwind.config"));
var _reactI18next = require("react-i18next");
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonUnchecked"));
var _constants = require("../../utils/constants");
var _doubleClick = _interopRequireDefault(require("../../hooks/doubleClick"));
var _excluded = ["checked", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (checked) {
    return /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], (0, _extends2["default"])({}, rest, {
      fontSize: "small",
      color: "primary",
      onClick: function onClick(e) {
        e.stopPropagation();
        onChange({
          target: {
            checked: false
          }
        });
      }
    }));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_RadioButtonUnchecked["default"], (0, _extends2["default"])({}, rest, {
      fontSize: "small",
      color: "danger",
      style: {
        fill: _tailwind.theme.extend.textColor.light
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        onChange({
          target: {
            checked: true
          }
        });
      }
    }));
  }
};
var ThemedLinearProgress = (0, _styles.withStyles)({
  barColorSecondary: {
    backgroundColor: _tailwind["default"].theme.colors.red
  }
})(_LinearProgress["default"]);
var ComposeAttachmentItem = function ComposeAttachmentItem(_ref2, ref) {
  var _ref2$wider = _ref2.wider,
    wider = _ref2$wider === void 0 ? false : _ref2$wider,
    contentType = _ref2.contentType,
    size = _ref2.size,
    name = _ref2.name,
    id = _ref2.id,
    src = _ref2.src,
    progress = _ref2.progress,
    scanStatus = _ref2.scanStatus,
    error = _ref2.error,
    onRemove = _ref2.onRemove,
    onRetry = _ref2.onRetry,
    selected = _ref2.selected,
    onSelect = _ref2.onSelect,
    onClick = _ref2.onClick,
    className = _ref2.className,
    onDoubleClick = _ref2.onDoubleClick;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var clickable = Boolean(onClick) && !error;
  var handleOriginalClick = function handleOriginalClick(e) {
    if (clickable) {
      onClick();
    }
  };
  var _useDoubleClick = (0, _doubleClick["default"])({
      onClick: handleOriginalClick,
      onDoubleClick: onDoubleClick
    }),
    handleClick = _useDoubleClick.onClick,
    handleDoubleClick = _useDoubleClick.onDoubleClick;
  var handleRemove = function handleRemove(e) {
    e.preventDefault();
    onRemove();
  };
  var handleRetry = function handleRetry(e) {
    e.preventDefault();
    e.stopPropagation();
    onRetry();
  };
  var progressNode = null;
  if (error || id || (0, _isNil["default"])(progress) || !(0, _isNil["default"])(scanStatus)) {
    progressNode = null;
  } else {
    progressNode = /*#__PURE__*/_react["default"].createElement(ThemedLinearProgress, {
      color: 'primary',
      className: "w-full",
      variant: "determinate",
      value: progress
    });
  }
  var headerNode = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("flex items-center Compose-attachment-header flex-none", {
      'justify-between': !wider,
      'justify-center': wider
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, scanStatus === _constants.attachmentScanStatus.INFECTED ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-semibold text-red text-xs"
  }, t('compose.upload.error.failed')), /*#__PURE__*/_react["default"].createElement(_Tooltip.HelpTooltip, {
    title: t('compose.upload.error.virusDetected')
  }, /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], {
    className: "text-red ml-1",
    fontSize: "small"
  }))) : scanStatus === _constants.attachmentScanStatus.BLOCKED ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-semibold text-red text-xs"
  }, t('compose.upload.error.failed')), /*#__PURE__*/_react["default"].createElement(_Tooltip.HelpTooltip, {
    title: t('compose.upload.error.blocked')
  }, /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], {
    className: "text-red ml-1",
    fontSize: "small"
  }))) : _constants.INCOMPLETE_SCAN_STATUS.includes(scanStatus) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    colored: true,
    contentType: contentType || 'others',
    style: {
      fontSize: '2rem'
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs ml-2"
  }, (0, _filesize["default"])(size)), /*#__PURE__*/_react["default"].createElement(_Tooltip.HelpTooltip, {
    title: t('compose.upload.warning.scanningFailed')
  }, /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], {
    className: "text-yellow ml-1",
    fontSize: "small"
  }))) : error ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-semibold text-red text-xs"
  }, t('compose.upload.error.failed')), /*#__PURE__*/_react["default"].createElement(_Tooltip.HelpTooltip, {
    title: error
  }, /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], {
    className: "text-red ml-1",
    fontSize: "small"
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    colored: true,
    contentType: contentType || 'others',
    fileName: name,
    style: {
      fontSize: '2rem'
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs ml-2"
  }, (0, _filesize["default"])(size)))), onRemove && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: t('button.removeAttachment')
  }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
    fontSize: "small",
    className: " Compose-attachment-clear cursor-pointer",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onMouseDown: handleRemove
  })));
  var bodyNode = wider ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center px-16",
    style: {
      height: 36
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('Compose-attachment-body w-full flex-none font-semibold text-xs '),
    title: name,
    style: {
      height: 'auto'
    }
  }, name)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('Compose-attachment-body flex-none font-semibold text-xs '),
    title: name
  }, name));
  var bottomNode = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-1 h-6 flex', {
      'justify-end': onSelect,
      'items-center': progressNode
    })
  }, error && /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-xs text-red  font-semibold",
    tabIndex: "-1",
    onMouseDown: handleRetry,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, t('button.retry')), progressNode, onSelect && /*#__PURE__*/_react["default"].createElement(Checkbox, {
    className: "Compose-attachment-checkbox",
    checked: selected,
    onChange: onSelect
  }));
  if (src) {
    var enableShow = error || progressNode || selected;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('Compose-attachment', {
        'bg-error': error,
        'dark:bg-secondary': !error,
        'cursor-pointer': clickable,
        'Compose-attachment-selected': selected
      }),
      onClick: handleClick,
      ref: ref
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('Compose-attachment-overlay flex-col p-2', {
        flex: enableShow,
        hidden: !enableShow
      })
    }, headerNode, bodyNode, bottomNode), /*#__PURE__*/_react["default"].createElement("img", {
      src: src,
      alt: name,
      className: "w-full h-full object-cover"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('Compose-attachment p-2 text-sm hover:bg-secondary', {
      'bg-error': error,
      'dark:bg-secondary': !error,
      'cursor-pointer': clickable,
      'Compose-attachment-selected': selected,
      wider: wider
    }, className),
    onClick: handleClick,
    onDoubleClick: handleDoubleClick,
    ref: ref
  }, headerNode, bodyNode, bottomNode);
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(ComposeAttachmentItem);
//# sourceMappingURL=index.js.map